"use client";

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm, SubmitHandler } from "react-hook-form";
import { toast } from "react-toastify";
import PhoneInput from "react-phone-input-2";
import OTPInput from "react-otp-input";
import ImagesData from "@assets/ImagesData";
import { Link, useNavigate, useLocation } from 'react-router-dom'
import services from "@api/services";
import { SlUserFollowing, LiaCitySolid, LiaEdit } from '@assets/Icons';
import { saveUserData, loginSuccess } from "@store/slices/authenticationSlice";
import { getCustomersAction, usersSeletor } from "@store/slices/userSlice";
import { authenticationSeletor } from "@store/slices/authenticationSlice";


import { mainUrl } from '@api/client/api.js'
import TALogin from "./TALogin";

const Login = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { access_token } = useSelector(authenticationSeletor);

  const [phoneVal, SetPhoneVal] = useState("");
  const [realPhoneVal, SetRealPhoneVal] = useState("");
  const [showScreen, setShowScreen] = useState("");
  const [userData, setUserData] = useState({});
  const [otp, setOtp] = useState("");
  const [defaultOtp, setDefaultOtp] = useState("");
  const [otherLogins, setOtherLogins] = useState(true);
  const [resendOtp, setResendOtp] = useState(false);
  const [count, setCount] = useState(30);
  const [otpButtonAnimation, setOtpButtonAnimation] = useState(false);
  const [otpError, setOtpError] = useState(false);

  const [userType, setUserType] = useState('customer')

  useEffect(() => {
    if (location.pathname == '/login') {
      document.getElementById('root').classList.add('no-padd');
    }

    return () => {
      document.getElementById('root').classList.remove('no-padd');
    }
  }, [])

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const timerForOtp = () => {
    const countRef = setTimeout(() => {
      setCount(() => count - 1);
    }, 1000);
    if (count <= 0) {
      clearTimeout(countRef);
      setResendOtp(true);
    }
  };

  useEffect(() => {
    if (showScreen === "otp") timerForOtp();
  }, [showScreen, count]);

  const loginHndler = async () => {
    let payload = { mobile: realPhoneVal };
    if (realPhoneVal.length != 10) {
      toast.error("Enter Correct Mobile Number*", {
        autoClose: 1000,
        pauseOnHover: true,
        position: "top-right",
      });
      return;
    }
    try {
      const res = await services.auth.userLogin(payload);
      if (res.status === 200) {
        if (!res.data.isNewUser) {
          // if (res.data.data.name === null) {
          //   setShowScreen("signup");
          //   setDefaultOtp(res.data.otp);
          // } else {
          setShowScreen("otp");
          setUserData(res.data.data);
          // }
        } else {
          setShowScreen("signup");
          setDefaultOtp(res.data.otp);
          setValue("phoneNumber", realPhoneVal);
        }
      }
    } catch (error) { }
  };

  const changeHandler = (value, country) => {
    SetPhoneVal(value);
    SetRealPhoneVal(value.replace(country.dialCode, ""));
  };

  const resendOTP = async (e) => {
    e.preventDefault();
    try {
      const res = await services.auth.userLogin({ mobile: realPhoneVal });
      if (res.status === 200) {
        toast.success(`OTP resend on ${realPhoneVal}*`, {
          autoClose: 1000,
          pauseOnHover: true,
          position: "top-right",
        });
        setCount(30);
        setResendOtp(false);
      }
    } catch (error) { }
  };

  const verifyHandler = async (payload) => {
    let payloadMain = {};
    if (showScreen === "otp") {
      if (otp.length < 4) {
        toast.error("Please Enter OTP*", {
          autoClose: 1000,
          pauseOnHover: true,
          position: "top-right",
        });
        return;
      }
      payloadMain = {
        mobile: userData.mobile,
        name: userData.name,
        email: userData.email,
        otp: otp,
        platform: 1,
      };
      try {
        setOtpButtonAnimation(true)
        const res = await services.auth.userVerify(payloadMain);
        if (res.status === 200 && res.data.success === true) {
          if (res?.data?.data.name && res?.data?.data.email) {
            dispatch(
              loginSuccess({
                data: { ...res?.data?.data, logintype: "normalUser" },
                token: res?.data?.token,
              })
            );
            // const res = await services.auth.getUserDetails(userDetail?.id);
          } else {
            const {
              createdAt,
              deletedAt,
              id,
              lastLogged,
              mobile,
              otp,
              password,
              updatedAt,
            } = res?.data?.data;
            const { name, email } = payloadMain;
            dispatch(
              loginSuccess({
                data: {
                  createdAt,
                  deletedAt,
                  id,
                  name,
                  email,
                  lastLogged,
                  mobile,
                  otp,
                  password,
                  updatedAt,
                  logintype: "normalUser",
                },
                token: res?.data?.token,
              })
            );
          }
          navigate("/");
        } else {
        }
      } catch (error) {
        if (error.response.status === 400) {
          setTimeout(() => {
            setOtpButtonAnimation(false)
            setOtpError(true)
            // toast.error("Invalid OTP. Please try again.", {
            //   autoClose: 2000,
            //   pauseOnHover: true,
            //   // position: "top-right",
            // });
          }, 1500)
        }
      }
    } else {
      payloadMain = {
        mobile: payload.phoneNumber,
        name: payload.name,
        email: payload.email,
        otp: defaultOtp,
      };
      setUserData(payloadMain);
      setShowScreen("otp");
    }
  };

  useEffect(() => {
    if (otp.length === 4 && showScreen === "otp") {
      verifyHandler()
    }
    setOtpError(false)
  }, [otp])

  if(access_token){
    navigate('/')
  }

  return (
    <div className="auth-page">
      <div className="container-lg">
        <div className="logo-area">
          <Link to="/" className="logo lg">
            <img src={ImagesData?.LogoIcon} title="" alt="" />
            <h1>RROOMS</h1>
          </Link>
        </div>
        <div className="img-benifits mb-6">
          <img src={ImagesData?.ImgLoginOff} title="" alt="" />
        </div>
        <div className="d-flex justify-content-between">
          <div className="left">
            <div className="text-white">
              <h6 className="fw-semi">We make your stay as enjoyable & comfortable as you can imagine.</h6>
              <h1><span className="d-block">Don't think,</span> Book in a blink !</h1>
              <h4 className="fw-semi paragraph">"Sign up with us now and enjoy substantial discounts and savings on every stay with RROOMS."</h4>
            </div>
            <div className="d-flex mt-6">
              <div className="column">
                <img src={ImagesData?.IconLoyalty} title="" alt="" />
                <div className="text-right">
                  <h4 className="fw-semibold">Loyalty Benefits</h4>
                  <p>Great discounts, guaranteed check-in</p>
                </div>
              </div>
              <div className="column">
                <img src={ImagesData?.IconFeature1} title="" alt="" />
                <div className="text-right">
                  <h4 className="fw-semibold">Exciting offers</h4>
                  <p>Avail exciting offers daily.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="right">
            <div className="auth-form">
              <div className="top">
                {
                  userType == 'customer' ? (
                    <>
                      {
                        showScreen === "" && (
                          <>
                            <h2 className="pb-6"><span className="text-brand">RROOMS</span> Stay Starts Here</h2>
                            <div className="form-group">
                              <label className="label mb-1">Mobile number</label>
                              <PhoneInput
                                country={"in"}
                                onlyCountries={["in"]}
                                value={phoneVal}
                                onChange={changeHandler}
                              />
                            </div>
                            <div className="form-group pt-1">
                              <button type="button" className="btn btn-info btn-block" onClick={loginHndler}>Continue</button>
                            </div>
                          </>
                        )
                      }
                      {
                        showScreen === "signup" && (
                          <form onSubmit={handleSubmit(verifyHandler)}>
                            <h2 className="pb-6"><span className="text-brand">RROOMS</span> Stay Starts Here</h2>
                            <div className="form-group">
                              <label className="label form-label mt-0 pt-0">Name</label>
                              <input
                                type="text"
                                id="name"
                                className="form-control"
                                placeholder="Enter name"
                                {...register("name", {
                                  required: "Name is required",
                                  pattern: {
                                    value: /^[A-Za-z\s]+$/,
                                    message: "Only alphabets and spaces are allowed",
                                  },
                                })}
                              />
                              {errors.name && (
                                <p className="text-danger fs-8 m-0">{errors.name.message}</p>
                              )}
                            </div>
                            <div className="form-group">
                              <label className="label form-label mt-0 pt-0">Email</label>
                              <input
                                type="text"
                                id="email"
                                placeholder="Enter email"
                                className="form-control"
                                {...register("email", {
                                  required: "Email is required",
                                  pattern: {
                                    value:
                                      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                    message: "Please enter a valid email",
                                  },
                                })}
                              />
                              {errors.email && (
                                <p className="text-danger fs-8 m-0">{errors.email.message}</p>
                              )}
                            </div>
                            <div className="form-group">
                              <label className="label form-label mt-0 pt-0">Phone Number</label>
                              <input
                                type="text"
                                id="phoneNumber"
                                placeholder="Enter Phone Number"
                                className="form-control"
                                disabled
                                {...register("phoneNumber", {
                                  required: "Phone number is required",
                                  pattern: {
                                    value: /^\d{10}$/,
                                    message: "Enter a valid 10-digit phone number",
                                  },
                                })}
                              />
                              {errors.phoneNumber && (
                                <p className="text-danger fs-8 m-0">{errors.phoneNumber.message}</p>
                              )}
                            </div>
                            <div className="form-group button">
                              <button type="submit" className="btn btn-primary btn-block">Sign Up</button>
                            </div>
                          </form>
                        )
                      }
                      {showScreen === "otp" && (
                        <form>
                          <h2 className="lg pb-6">Verify OTP</h2>
                          <div className="form-group">
                            <OTPInput
                              value={otp}
                              onChange={setOtp}
                              numInputs={4}
                              shouldAutoFocus={true}
                              renderInput={(props) => (
                                <input
                                  {...props}
                                  type="number"
                                  className="Otp-form-control"
                                />
                              )}
                            />
                            {otpError && <p className="text-error" style={{ fontSize: '12px', color: '#f00', margin: '5px 0px 0px' }}>Invalid OTP. Please try again.</p>}
                          </div>
                          <p className="v-center mb-2">
                            <span>{phoneVal}</span>
                            <span className="text-secondary ml-2" onClick={() => setShowScreen("")}>
                              <LiaEdit size={20} />
                            </span>
                          </p>
                          <div className="form-group">
                            <button
                              type="button"
                              onClick={verifyHandler}
                              className="btn btn-info btn-block"
                              disabled={otp.length !== 4}
                              style={{ minWidth: '250px' }}>
                              {
                                otp.length === 4 && otpButtonAnimation ? (
                                  <><span className="dot-loader"></span> Verifying...</>
                                ) : 'Verify OTP'
                              }
                            </button>
                          </div>
                          {resendOtp ? (
                            <a
                              href="#"
                              className="termsparagraph m-0"
                              style={{ color: "#ff0018" }}
                              onClick={(e) => resendOTP(e)}
                            >
                              Resend OTP
                            </a>
                          ) : (
                            <p className="m-0 termsparagraph">
                              Resend OTP in {`00:${count > 9 ? count : `0${count}`}`}
                            </p>
                          )}
                        </form>
                      )}
                    </>
                  )  : (
                    <TALogin />
                  )
                }
              </div>
              <div className="tag">
                <span>Or sign in as</span>
              </div>
              <div className="bottom">
                <div className="login-options">
                  <ul>
                    <li>
                      <a target="_blank" href={mainUrl == 'https://rrooms.in/rrooms/' ? 'https://rrooms360.in/' : 'https://rrooms360.rrooms.in/login'} className="btn-mat btn-mat-secondary">
                        Login to Extranet
                      </a>
                    </li>
                    <li>
                      <a onClick={()=> setUserType(userType == 'customer' ? 'ta' : 'customer')} className="btn-mat btn-mat-secondary">
                        Login as {userType == 'customer' ? 'Travel Agent' : 'Customer'}
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="text-center">
                  <p className="fs-7">
                    By proceeding, you agree to RRooms's Read all<br />
                    <Link href="/" className="text-secondary">Hotel policies User Agreement</Link>  and
                    <Link href="/" className="text-secondary"> Terms of Service</Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login